export const formatGlobalActionRecentActivity = (item) => {
  const rawValue = item?.updated_time ?? item?.created_time ?? null;
  if (!rawValue) return 'N/A';

  const parsedDate = new Date(rawValue);
  if (Number.isNaN(parsedDate.getTime())) return 'N/A';

  return parsedDate.toLocaleString([], {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
  });
};
